import { ExclusionConfirmationMethodModal } from 'components/ExclusionConfirmationMethodModal'
import { UserUpdateModal } from 'components/UserUpdateModal'
import { useMetadataUser } from 'contexts/metadata-user-context'
import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { FaRegTrashCan } from 'react-icons/fa6'
import { FiEdit } from 'react-icons/fi'
import { deleteUser } from 'services/delete-user'
import { fetchUsers, User } from 'services/fetch-users'
import { Body, updateUser } from 'services/update-user'

import { MainAccountLayout } from '../main-layout'

export function UserTable() {
  const { profile } = useMetadataUser()
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false)

  const [userId, setUserId] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingAction, setIsLoadingAction] = useState(false)
  const [users, setUsers] = useState<User[]>([])
  const [user, setUser] = useState<User>()

  const handleDeleteUser = () => {
    setIsLoadingAction(true)
    deleteUser(userId)
      .then(() => {
        setIsOpenDeleteModal(false)
        window.location.reload()
        setIsLoadingAction(false)
      })
      .catch((error) => {
        toast.error(error?.message ?? 'Erro ao excluir usuário')
      })
      .finally(() => {
        setIsLoadingAction(false)
      })
  }

  const handleUpdateUser = (body: Body) => {
    setIsLoadingAction(true)
    updateUser(body, userId)
      .then(() => {
        setIsOpenUpdateModal(false)
        toast.success('Usuário atualizado com sucesso')

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
      .catch((error) => {
        toast.error(error?.message ?? 'Erro ao atualizar usuário')
      })
      .finally(() => {
        setIsLoadingAction(false)
      })
  }

  useEffect(() => {
    setIsLoading(true)
    fetchUsers()
      .then((response) => {
        setUsers(response)
      })
      .catch((error) => {
        toast.error(error?.message ?? 'Erro ao buscar usuários')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100svh-15rem)]">
        <p>Carregando...</p>
      </div>
    )
  }

  if (users?.length === 0 && !isLoading) {
    return (
      <MainAccountLayout className="!mt-4">
        <p className="text-center text-lg text-neutral-500 dark:text-neutral-400 w-full">
          Nenhum usuário cadastrado
        </p>
      </MainAccountLayout>
    )
  }

  return (
    <MainAccountLayout className="!mt-4">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-neutral-700">
        <thead className="bg-neutral-100 dark:bg-neutral-800">
          <tr>
            <th className="text-left py-2 px-4 pl-6 font-medium text-neutral-600 dark:text-neutral-200">
              Nome
            </th>
            <th className="text-center py-2 px-4 font-medium text-neutral-600 dark:text-neutral-200">
              E-mail
            </th>
            <th className="text-right py-2 px-4 font-medium text-neutral-600 dark:text-neutral-200">
              {' '}
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-neutral-700">
          {users
            .toSorted((user) => (user.id === profile?.id ? -1 : 1))
            .map((user) => (
              <tr key={user.id}>
                <td className="py-4 px-4 pl-6">{user.name}</td>
                <td className="py-4 px-4 text-center">{user.email}</td>
                <td className="py-4 px-4 text-right pr-10 space-x-10">
                  {profile?.id === user?.id ? (
                    <button
                      onClick={() => {
                        setIsOpenUpdateModal(true)
                        setUserId(user.id)
                        setUser(user)
                      }}
                    >
                      <FiEdit className="w-6 h-6 cursor-pointer hover:text-[#6366F1]" />
                    </button>
                  ) : null}

                  <button
                    onClick={() => {
                      setIsOpenDeleteModal(true)
                      setUserId(user.id)
                    }}
                  >
                    <FaRegTrashCan className="w-6 h-6 cursor-pointer hover:text-[#6366F1]" />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {isOpenDeleteModal && (
        <ExclusionConfirmationMethodModal
          title="Tem certeza que deseja excluir esse usuário?"
          handleEvent={handleDeleteUser}
          setIsOpenModal={setIsOpenDeleteModal}
          isLoading={isLoadingAction}
        />
      )}
      {isOpenUpdateModal && (
        <UserUpdateModal
          userData={user}
          handleEvent={handleUpdateUser}
          setIsOpenModal={setIsOpenUpdateModal}
          isLoading={isLoadingAction}
        />
      )}
    </MainAccountLayout>
  )
}
